const checkboxesFormat = [
  {
    key: 0,
    value: "Jeunes",
    check: false,
    swim: "50 m à 300 m",
    bike: "1 km à 6 km",
    run: "500 m à 2 km",
  },
  {
    key: 1,
    value: "XXS",
    check: false,
    swim: "200 m",
    bike: "5 km",
    run: "1,5 km",
  },
  {
    key: 2,
    value: "XS",
    check: false,
    swim: "400 m",
    bike: "10 km",
    run: "2,5 km",
  },
  {
    key: 3,
    value: "S",
    check: false,
    swim: "750",
    bike: "20 km",
    run: "5 km",
  },
  {
    key: 4,
    value: "M",
    check: false,
    swim: "1500",
    bike: "40 km",
    run: "10 km",
  },
  {
    key: 5,
    value: "L",
    check: false,
    swim: "1900 m",
    bike: "90 km",
    run: "21,1 km",
  },
  {
    key: 6,
    value: "XL",
    check: false,
    swim: "4000 m",
    bike: "120 km",
    run: "30 km",
  },
  {
    key: 7,
    value: "XXL",
    check: false,
    swim: "3800 m",
    bike: "180 km",
    run: "42,2 km",
  },
];

export default checkboxesFormat;
